import { Component, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { Subscription } from 'rxjs';
import { DQOIItem } from '../shared/models/DQOIItem';
import { DQOIService } from '../shared/services/DQOI.service';
import { OrdersComponent } from '../orders/orders.component';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { DQOISearchEvent } from '../shared/models/DQOISearchEvent';

import { DQOIReferenceData } from '../shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '../shared/base-components/base-dqoi.component';
import { DispatchesService } from '../shared/services/dispatches.service';
import { DispatchPage } from '../shared/models/DispatchPage';
import { UseCPLoader, ICPLoader } from '../shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'order-qv',
    templateUrl: './order-qv.component.html',
    styleUrls: ['./order-qv.component.scss']
})
export class OrderQvComponent  implements OnDestroy {

    compLoader: ICPLoader = this as any;
    @ViewChild('mainComp') mainComp: OrdersComponent;
    @Output() closed = new EventEmitter<any>();
    svc_data: DQOIService;
    qry_rd: DQOIReferenceDataQuery;
    public orderNumber: string;
    subs_dataRef: Subscription;
    pageData: DispatchPage;
    dispatchId: string;
    dispatchNumber: string;
    constructor(
        public globals: GlobalsService,
        svc_data: DQOIService, qry_rd: DQOIReferenceDataQuery, svc_dispatch_data: DispatchesService,) {

        this.svc_data = svc_data;
        this.qry_rd = qry_rd;
        this.pageData = new DispatchPage(svc_dispatch_data);
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();

    }

    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_dataRef);
    }
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceData !== undefined && this.referenceData !== null && CommonFunctions.hasArrayElementValue(this.referenceData.dispatchStatus) ? true : false;
        }
        catch {
            retVal = false;
        }
        return retVal;

    }

    dqoiItem: DQOIItem;
    isConstruction: boolean = false;
    clear() {
        this.orderNumber = '';
        this.mainComp.clear();
    }
    active: boolean = false;
    SetValue(value: any) {
        this.dispatchId = null;
        this.pageData.dispatchAttachments = [];
        this.pageData.dispatchNotes = [];
        if (value) {

            //  this.clear();
            this.active = true;
            this.orderNumber = value.orderNumber;
            if (CommonFunctions.hasGuidValue(value.orderId)) {
                let idTarget = SearchTarget.order + ":" + value.orderId;
                this.svc_data.getDQOITemFromDb(idTarget).subscribe((newData: DQOIItem) => {
                    let item: DQOIItem = new DQOIItem(newData);
                    item.index = 1;
                    this.isConstruction = item.isConstruction;

                    this.svc_data.setDQOIItem(item);
                    let se: DQOISearchEvent = new DQOISearchEvent();
                    se.isNew = false;
                    se.searchTarget = SearchTarget.order;
                    se.orderNumber = item.orderNumber;
                    se.dqoiItem = item;
                    this.svc_data.nextSearchEvent(se);

                });
            }
            if (CommonFunctions.hasGuidValue(value.dispatchId)) {
                this.dispatchId = value.dispatchId;
                this.dispatchNumber = value.dispatchNumber;
                this.pageData.getDispatchNotes(value.dispatchId);
                this.pageData.getDispatchAttachments(value.dispatchId);

            }
        }
    }
    closeWindow() {

        this.active = false;
        this.closed.emit();
        this.clear();
    }
    loadJob(id: any) {
        if (id) {
            let url: string = "/quickview/construction/10/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadContract(id: any) {
        if (id) {
            let url: string = "/quickview/construction/9/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadDispatch(id: any) {
        if (id) {
            let url: string = "/quickview/service/10/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadOrder(value: any) {

        if (value.isConstruction) {
            this.loadOrderContruction(value.orderId);

        } else {
            this.loadOrderService(value.orderId);

        }

    }
    loadOrderContruction(id: any) {
        if (id) {
            let url: string = "/quickview/construction/3/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadOrderService(id: any) {
        if (id) {
            let url: string = "/quickview/service/3/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
        //this.router.navigateByUrl(url);
    }

}
